import classnames from 'classnames'
import PropTypes from 'prop-types'

import {Map} from 'immutable'

import {Badge} from '@mui/material'

import {
  useOrganizationCobranding
} from '../../../../../shared_components/OrganizationCobrandingContext'

import UserAvatar from '../../../../../shared_components/mui_base_components/avatar/UserAvatar'
import {hasOrganizationCobranding} from '../../../../../lib/cobrandingTools'

const DeputyForAvatar = ({deputizer, onClick}) => {
  const everplanOwners = deputizer.getIn(['everplan-owner', 'owners'])

  const organizationCobranding = useOrganizationCobranding()

  const sharedProps = {
    className: classnames('deputizer-avatar', {
      'with-everplans-custom-colors': !hasOrganizationCobranding(
        organizationCobranding
      )
    }),
    isPending: deputizer.get('ownable-type') === 'Invite',
    onClick,
    user: everplanOwners.first()
  }

  return (
    deputizer.getIn(['everplan-owner', 'is-household']) ?
      <Badge
        className='badge'
        overlap='circular'
        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
        badgeContent={
          <UserAvatar
            {...sharedProps}
            className={`${sharedProps.className} badge`}
          />
        }>
        <UserAvatar {...sharedProps} user={everplanOwners.last()} />
      </Badge> :
      <UserAvatar {...sharedProps} />
  )
}

DeputyForAvatar.propTypes = {
  deputizer: PropTypes.instanceOf(Map),
  onClick: PropTypes.func
}

export default DeputyForAvatar
